<template>
    <div class="modal fade show custom-modal" :class="{'modal-show':showOtpVerifyModal}">
        <div class="modal-dialog">
        <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header mt-4 mx-4 mb-0 p-0 border-bottom">
                    <h4 class="modal-title">OTP Verification</h4>
                    <button id="close_button" type="button" class="close" @click="closeModal()">&times;</button>
                </div>
                <div class="px-4 text-center">
                    <div class="my-3">
                        <p class="m-0">
                            Please Enter OTP sent on
                        </p>
                        <p class="m-0">
                            policy holder’s phone number or email to verify
                        </p>
                    </div>
                    <div class="otp-form">
                        <input type="password" name="" v-model="verifyOtp.otpValue" id="otp_input" 
                               class="otp-input text-center" v-on:keydown="onlyNumber" maxlength="6">
                        <button id = "resend_otp" class="btn btn-default my-2 p-0 d-block mx-auto text-primary" @click="callSendOtp()">
                            Re-send OTP
                        </button>
                    </div>
                </div>
                <div class="modal-footer mx-4 mb-2border-0">
                    <button type="button" class="bgc-btn-primary mx-auto" :disabled="verifyOtp.otpValue==''"
                    @click="verifyOtpParent()">Verify</button>
                    <span v-if="verifyOtp.otpVerifyLoaderStatus" class="search-loader small inline"><img src="@/assets/images/loader.gif" alt="Otp Update Loader"
                    class="search-loader-breakdown"/></span>
                </div>
                <div class="otp-errormsg text-center">{{verifyOtp.otpErrorMsg}}</div>
            </div>
        </div>
    </div>
</template>
<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue"
import functions from '@/../../masters/functions.js';
import { reactive } from '@vue/composition-api';
export default {
  name: "OTPVerifyModal",
  props:['showOtpVerifyModal','verifyOtp'],
  components: {
    FloatLabel
  },
  setup(props,context){
    let state = reactive({
      
    });
    //methods
    const onlyNumber= functions.onlyNumber;
    function closeModal(){
        props.verifyOtp.otpValue='';
        props.verifyOtp.otpErrorMsg='';
        context.parent.closeOtpModal();
    }
    function callSendOtp(){
        context.parent.callSendOtp();
    }
    function verifyOtpParent(){
        context.parent.verifyOtpParent();
    }
    return{
      onlyNumber,
      closeModal,
      callSendOtp,
      verifyOtpParent
    }
  }
};
</script>

<style scoped>
.otp-errormsg{
    color: red;
}
.btn-default{
    background: #fff;
}
.search-loader img{
  width: 30px;
  height: 30px;
  left: 64%;
  bottom: 8%;
  position: absolute;
}
.custom-modal{
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,0.4);
    transform:scale(0);
}
.modal-show{
    display:block;
    transform:scaleY(0) scaleX(0);
    animation:unfoldIn 0.25s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
}
.otp-input{
    padding: 5px 10px;
    height: 50px;
    border-radius: 5px;
    border: 1px solid #d1d1d1;
    outline: none;
    width: 200px;
    font-size: 24px;
}
</style>